<template>
  <div
    :id="'chart-' + _uid"
    :class="chartType !== 'table' ? 'singlechart' : 'singlechart tableview'"
    :layout="responsive"
  >
    <visualization-controls-compact
      v-if="visualization && chartType==='worldmap' && showControls"
      :visualization="visualization"
      :show-color="true"
      :show-sort-z="query.zlayers.length > 0"
      :show-recency="true"
      :show-size="true"
    ></visualization-controls-compact>
    <visualization-controls-compact
      v-if="visualization && chartType==='barchart' && showControls"
      :visualization="visualization"
      :show-color="true"
      :show-metric="true"
      :show-sort-x="true"
      :show-sort-z="query.zlayers.length > 0"
      :show-recency="true"
      :show-size="true"
    ></visualization-controls-compact>
    <visualization-controls-compact
      v-if="visualization && chartType==='scatterplot' && showControls"
      :visualization="visualization"
      :show-metric-x="true"
      :show-metric-y="true"
      :show-sort-z="query.zlayers.length > 0"
      :show-recency="true"
      :show-size="true"
    ></visualization-controls-compact>
    <visualization-controls-compact
      v-if="visualization && chartType==='linechart' && showControls"
      :visualization="visualization"
      :show-color="true"
      :show-recency="true"
      :show-sort-x="true"
      :show-size="true"
    ></visualization-controls-compact>
    <visualization-controls-compact
      v-if="visualization && chartType==='heatmap' && showControls"
      :visualization="visualization"
      :show-color="true"
      :show-sort-x="true"
      :show-sort-y="true"
      :show-sort-z="query.zlayers.length > 0"
      :show-recency="true"
      :show-size="true"
      :show-normalize-x="true"
    ></visualization-controls-compact>
    <visualization-controls-compact
      v-if="visualization && chartType==='columnchart' && showControls"
      :visualization="visualization"
      :show-color="true"
      :show-metric="true"
      :show-sort-x="true"
      :show-sort-z="query.zlayers.length > 0"
      :show-recency="true"
      :show-size="true"
    ></visualization-controls-compact>
    <div v-if="chartType === 'table'" class="table-view show-scroll">
      <b-row id="tableview-head-row" class="table-view_headrow">
        <b-col class="table-view_headrow_col" cols="1">Nr</b-col>
        <b-col cols="7" class="table-view_headrow_col">Name</b-col>
        <b-col cols="2" class="table-view_headrow_col">Size</b-col>
        <b-col cols="2" class="table-view_headrow_col">Recency</b-col>
      </b-row>
      <b-row
        v-for="(row, item) in tableData"
        :key="row.id"
        class="table-view_row"
      >
        <b-col class="table-view_row_col" cols="1">
          <div class="table-view_row_col__count">{{ item + 1 }}</div>
        </b-col>
        <b-col :id="row.id" cols="7" class="table-view_row_col">
          <div
            class="table-view_row_col__count"
            :class="{ active: isSelected(row.id) }"
          >
            <b-link @click="showOptions(row)">{{ row.name }}</b-link>
          </div>
        </b-col>
        <b-col
          cols="2"
          class="table-view_row_col d-flex flex-column justify-content-center"
        >
          <div class="table-view_row_col__docs">{{ row.size }}</div>
        </b-col>
        <b-col
          cols="2"
          class="table-view_row_col d-flex flex-column justify-content-center"
        >
          <div class="table-view_row_col__docs">{{ row.recency }}</div>
        </b-col>
      </b-row>
    </div>
    <div v-else id="svgDiv">
      <svg></svg>
      <div v-if="chartType ==='heatmap'" id="load-div-heatmap" class="loading-visualization" :class="{'show': showLoader}">
        <div class="d-flex justify-content-center">
          <div class="loader">
            <div class="cube"></div>
            <div class="cube"></div>
            <div class="cube"></div>
          </div>
        </div>
      </div>
      <div v-if="chartType ==='onedheatmap'" id="load-div-onedheatmap" class="loading-visualization" :class="{'show': showLoader}">
        <div class="d-flex justify-content-center">
          <div class="loader">
            <div class="cube"></div>
            <div class="cube"></div>
            <div class="cube"></div>
          </div>
        </div>
      </div>
      <div v-if="chartType ==='barchart'" id="load-div-barchart" class="loading-visualization" :class="{'show': showLoader}">
        <div class="d-flex justify-content-center">
          <div class="loader">
            <div class="cube"></div>
            <div class="cube"></div>
            <div class="cube"></div>
          </div>
        </div>
      </div>
      <div v-if="chartType ==='columnchart'" id="load-div-columnchart" class="loading-visualization" :class="{'show': showLoader}">
        <div class="d-flex justify-content-center">
          <div class="loader">
            <div class="cube"></div>
            <div class="cube"></div>
            <div class="cube"></div>
          </div>
        </div>
      </div>
      <div v-if="chartType ==='worldmap'" id="load-div-worldmap" class="loading-visualization" :class="{'show': showLoader}">
        <div class="d-flex justify-content-center">
          <div class="loader">
            <div class="cube"></div>
            <div class="cube"></div>
            <div class="cube"></div>
          </div>
        </div>
      </div>
      <div v-if="chartType ==='scatterplot'" id="load-div-plot" class="loading-visualization" :class="{'show': showLoader}">
        <div class="d-flex justify-content-center">
          <div class="loader">
            <div class="cube"></div>
            <div class="cube"></div>
            <div class="cube"></div>
          </div>
        </div>
      </div>
      <div v-if="chartType ==='linechart'" id="load-div-linechart" class="loading-visualization" :class="{'show': showLoader}">
        <div class="d-flex justify-content-center">
          <div class="loader">
            <div class="cube"></div>
            <div class="cube"></div>
            <div class="cube"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters, mapState } from "vuex";
import { EventBus } from "@/eventBus";
import GeneralChart from "./GeneralChart";
import ScatterPlot from "./ScatterPlot";
import { CrainData } from "./shared/CrainD3Vis";
import { getFiltId, getMemberFilters } from "../../../helpers/PrepFilters";
import VisualizationControlsCompact from "@/components/Explore/Visualizations/VisualizationControlsCompact";

export default {
  name: "SingleChartView",
  components: {
    VisualizationControlsCompact
  },
  props: {
    analyse: {
      required: true,
      type: Object
    },
    settings: {
      required: false,
      type: Object,
      default: null
    },
    responsive: {
      required: true,
      type: Boolean
    },
    block: {
      required: true,
      type: Number
    },
    chartType: {
      required: true,
      type: String
    },
    showControls: {
      type: Boolean
    }
  },
  data() {
    return {
      defaultsLoaded: false,
      years: [],
      query: null,
      queryValid: true,
      currChartType: "none",
      color: "recency",
      colorOptions: [{ value: "size", text: "Size" }],
      metric: "size",
      logMetricX: false,
      logMetricY: true,
      metricX: "recency",
      metricXOptions: [
        { value: "size", text: "Size" },
        { value: "recency", text: "Recency" }
      ],
      metricY: "size",
      metricYOptions: [
        { value: "size", text: "Size" },
        { value: "recency", text: "Recency" }
      ],
      sortX: "normal",
      sortY: "normal",
      typeCats: true,
      sortZ: 0,
      sortZOptions: [{ value: 0, text: "All" }],
      normalizeOverX: false,
      visualization: null,
      sizeLimit: 0,
      sizeRange: null,
      recencyLimit: [-3, 3],
      recencyRange: [-3, 3],
      table: null,
      tableData: [],
      selectedRows: [],
      selectedRowIds: [],
      showLoader: true,
      visDrawCheck: null
    };
  },
  computed: {
    ...mapGetters(["activeVisual"]),
    ...mapState({
      filters: state => state.filter.filters,
      filterFocused: state => state.filter.filterFocused,
      subsetFilter: state => state.filter.subsetFilter
    }),
    visualSelection() {
      return this.subsetFilter;
    },
    focused() {
      return this.filterFocused;
    },
    queryStringified: {
      get() {
        return JSON.stringify(this.analyse.config.query);
      },
      set(val) {
        try {
          this.analyse.config.query = JSON.parse(val);
          this.queryValid = true;
        } catch (error) {
          this.queryValid = false;
        }
      }
    },
    enableLogMetricX() {
      if (
        this.metricX === "size" ||
        this.metricX === "origsize" ||
        this.metricX === "filtsize"
      ) {
        return true;
      }

      return false;
    },
    enableLogMetricY() {
      if (
        this.metricY === "size" ||
        this.metricY === "origsize" ||
        this.metricY === "filtsize"
      ) {
        return true;
      }

      return false;
    },
    clusteringEnabled() {
      return this.analyse.config.query.postprocessing.includes("clustering");
    },
    sortXOptions() {
      return [
        { value: "normal", text: "Normal" },
        { value: "size", text: "Size" },
        { value: "size_des", text: "Size descending" },
        { value: "recency", text: "Recency" },
        { value: "recency_des", text: "Recency descending" },
        {
          value: "clustering",
          text: "Clustering",
          disabled: !this.clusteringEnabled
        },
        {
          value: "clustering_docs",
          text: "Clustering (Documents)",
          disabled: !this.clusteringEnabled
        }
      ];
    },
    sortYOptions() {
      return [
        { value: "normal", text: "Normal" },
        { value: "size", text: "Size" },
        { value: "size_des", text: "Size descending" },
        { value: "recency", text: "Recency" },
        { value: "recency_des", text: "Recency descending" },
        {
          value: "clustering",
          text: "Clustering",
          disabled: !this.clusteringEnabled
        },
        {
          value: "clustering_docs",
          text: "Clustering (Documents)",
          disabled: !this.clusteringEnabled
        }
      ];
    }
  },
  watch: {
    visualSelection() {
      //this.loadAnimStart();
      //this.saveLoadingStep("Drawing "+this.chartType);
      if (!this.activeVisual.includes("#chart-" + this._uid + " svg")) {
        //console.log("Updating #chart-" + this._uid);
        this.query.subset_filters =
          this.subsetFilter.length > 0
            ? [this.subsetFilter]
            : this.filterFocused
            ? this.filterFocused.rawquery
            : [];
        setTimeout(() => {
          this.executeQuery(this.query, this.chartType, true);
        }, this.block*500)
        
        
        
      }
    },
    focused() {
      //this.loadAnimStart();
      //this.saveLoadingStep("Drawing "+this.chartType);
      if (this.subsetFilter.length > 0) {
        let subset = this.subsetFilter;
        if (this.subsetFilter.length > 0) {
          subset.splice(-2);
        }
        this.query.subset_filters = [
          subset,
          "AND",
          this.filterFocused.rawquery
        ];
      } else {
        this.query.subset_filters = this.filterFocused
          ? [this.filterFocused.rawquery]
          : [];
      }
      setTimeout(() => {
        this.executeQuery(this.query, this.chartType, true);
      }, this.block*500)

      
    },
    settings: {
      handler: function(value, old) {
        if (value !== null) {
          this.showLoader = true;
          //console.log("Settings:",value);
          this.color = value.color;
          this.metric = value.metric;
          this.sortZ = value.sortZ;
          this.sortX = value.sortX;
          this.sortY = value.sortY;
          this.normalizeOverX = value.normalizeOverX;
          this.sizeLimit = value.sizeLimit;
          this.metricX = value.metricX;
          this.metricY = value.metricY;
          this.typeCats = value.typeCats;
          this.years = value.years;
          if(JSON.stringify(this.recencyLimit) !== JSON.stringify(value.recencyLimit)){
            this.recencyLimit = value.recencyLimit;
            this.visualization.queryUpdated = false;
            this.visualization.setRecencyLimit(value.recencyLimit);
          }
        }
      },
      deep: true
    },
    analyse() {
      this.loadAnimStart();
      this.saveLoadingStep("Redrawing.....");
      setTimeout(() => {
        this.loadAnimEnd();
      }, 1000);
      this.query = { ...this.analyse.config.query };
      this.query.subset_filters =
        this.subsetFilter.length > 0
          ? [this.subsetFilter]
          : this.filterFocused
          ? this.filterFocused.rawquery
          : [];
      this.executeQuery(this.query, this.chartType);
    },
    chartType(val) {
      this.visualization.queryUpdated = false;
      this.executeQuery(this.query, this.chartType);
      setTimeout(() => {
        this.color = this.settings.color;
        this.sortZ = this.settings.sortZ;
        this.sortX = this.settings.sortX;
        this.normalizeOverX = this.settings.normalizeOverX;
        this.sizeLimit = this.settings.sizeLimit;
        this.recencyLimit = this.settings.recencyLimit;
      }, 100);
      this.currChartType = val;
    },
    years() {
      if (this.years !== undefined) {
        this.query.startyear = Object.values(this.years)[0];
        this.query.recentyear = Object.values(this.years)[1];
        this.query.stopyear = Object.values(this.years)[2];
        this.query.subset_filters =
          this.subsetFilter.length > 0
            ? [this.subsetFilter]
            : this.filterFocused
            ? this.filterFocused.rawquery
            : [];
        this.executeQuery(this.query, this.chartType);
      }
    },
    /*
    visualization: {
      handler: function(value, old) {
        this.$emit("setDefault", {
          ...this.settings,
          ...{
            "colorOptions": value.colorOptions,
            "metricXOptions": value.metricOptions,
            "metricYOptions": value.metricOptions,
            "sortXOptions": value.sortXYOptions,
            "sortYOptions": value.sortXYOptions,
            "sizeLimit": value.sizeRange,
            "sizeRange": value.sizeRange,
            "recencyLimit": value.recencyRange,
            "recencyRange": value.recencyRange, 
          }  
        });

        //this.loadAnimEnd();
        //this.saveLoadingStep("");

      },
      deep: true
    }*/
    showLoader(val, old){
      if(val !== old){
        if(val){
          this.startVisCheckInt();
        }
        else{
          clearInterval(this.visDrawCheck);
        }
      }
    }
  },
  mounted() {
    if (!this._uid) {
      console.error("Please set ID property");
      return false;
    }
    
    this.startVisCheckInt();

    let value = this.settings;
    this.color = value.color;
    this.metric = value.metric;
    this.sortZ = value.sortZ;
    this.sortX = value.sortX;
    this.sortY = value.sortY;
    this.normalizeOverX = value.normalizeOverX;
    this.metricX = value.metricX;
    this.metricY = value.metricY;
    this.typeCats = value.typeCats;
    this.years = value.years;

    this.query = { ...this.analyse.config.query };
    this.query.subset_filters = this.filterFocused
      ? [this.filterFocused.rawquery]
      : [];
    if (this.chartType === "table") {
      this.table = new CrainData(JSON.stringify(this.query));

      this.table.load().then(res => {
        this.tableData = [];
        res.xLayers.forEach(element => {
          this.tableData.push({
            id: element[0]._id,
            name: element[0].name,
            type: element[0].type
          });
        });
        let index = 0;
        res.processedData.forEach(element => {
          this.tableData[index].size = element.data.size;
          this.tableData[index].recency = element.data.recency;
          index++;
        });
      });
    } else {
      if (this.chartType === "scatterplot") {
        this.visualization = new ScatterPlot(
          "#chart-" + this._uid + " svg",
          this.chartType,
          this.settings
        );
      } else {
        this.visualization = new GeneralChart(
          "#chart-" + this._uid + " svg",
          this.chartType,
          this.settings
        );
      }

      setTimeout(() => {
        this.executeQuery(this.query, this.chartType);
      }, this.block*500)
    }

    /*if(this.chartType === 'scatterplot'){
      this.sortZOptions = this.visualization.getPlotMetricData.sortZoptions;
      this.sortZ = this.sortZOptions[0].value;
      this.metricXOptions = this.visualization.getPlotMetricData.metricOptions;
      this.metricYOptions = this.metricXOptions;
      this.sizeLimit = this.visualization.getPlotMetricData.sizeRange;
      this.sizeRange = this.sizeLimit;
      this.recencyLimit = this.visualization.getPlotMetricData.recencyRange;
      this.recencyRange = this.recencyLimit;
    }
    else{
      this.colorOptions = this.visualization.getSeparatedColorOptions();
      this.metricXOptions = this.visualization.getSeparatedMetricOptions();
      this.metricYOptions = this.metricXOptions;
      this.sizeLimit = this.visualization.sizeRange;
      this.sizeRange = this.visualization.sizeRange;
      this.recencyLimit = this.visualization.recencyRange;
      this.recencyRange = this.visualization.recencyRange;
    }*/
    
    EventBus.$on("resizeSingleChart", (item) => {
      if(this.settings.block === item.vis){
        //console.log("Resizing chart", item);
        this.visualization.queryUpdated = false;
        if(item.act === "max"){
          this.visualization.setLabelVisibility = true;
        }
        else{
          this.visualization.setLabelVisibility = false;
        }
        this.visualization.draw(true);
      }
    });
  },
  destroyed() {
    clearInterval(this.visDrawCheck);
    if (this.chartType !== "table") {
      this.visualization.destroy();
      console.log(this.chartType, "Destroyed");
    }
  },
  methods: {
    ...mapActions(["saveFilter", "deleteFilter", "saveSubsetFilter", "saveActiveVisual", "loadAnimStart", "loadAnimEnd", "saveLoadingStep"]),
    async executeQuery(real_query, cType, update=false) {
      //console.log(real_query);
      let query = await this.modifyQueryForFilterGroup(real_query);
      //console.log(query);
      if(query){
        //query = real_query;
      if (cType === "table") {
        if (this.table.request !== JSON.stringify(query)) {
          this.table = new CrainData(JSON.stringify(query));
          this.table.load().then(res => {
            this.tableData = [];
            res.xLayers.forEach(element => {
              this.tableData.push({
                id: element[0]._id,
                name: element[0].name,
                type: element[0].type
              });
            });
            let index = 0;
            res.processedData.forEach(element => {
              this.tableData[index].size = element.data.size;
              this.tableData[index].recency = element.data.recency;
              index++;
            });
          });
        } else {
          this.tableData = [];
          this.table.xLayers.forEach(element => {
            this.tableData.push({
              id: element[0]._id,
              name: element[0].name,
              type: element[0].type
            });
          });
          let index = 0;
          this.table.processedData.forEach(element => {
            this.tableData[index].size = element.data.size;
            this.tableData[index].recency = element.data.recency;
            index++;
          });
        }
      } else {
        if (cType === "scatterplot" && this.currChartType !== "scatterplot") {
          this.visualization = new ScatterPlot(
            "#chart-" + this._uid + " svg",
            cType,
            this.settings
          );
        } else if (
          this.currChartType === "scatterplot" &&
          cType !== "scatterplot"
        ) {
          this.visualization = new GeneralChart(
            "#chart-" + this._uid + " svg",
            this.chartType,
            this.settings
          );
        }
        if (this.visualization.query !== JSON.stringify(query)) {
          this.visualization.queryUpdated = true;
        }
        this.visualization.setQuery(query, false);
        if(this.subsetFilter.length > 0 || this.filterFocused){
            if(cType === 'scatterplot'){
              //this.settings.metricX = "filtrecency";
              //this.settings.metricY = "filtsize";
              this.visualization.setMetricX("filtrecency", false);
              this.visualization.setMetricY("filtsize", false);
              this.visualization.setDataLimit(true, false);
            }
            else if(cType === 'linechart'){
              this.visualization.setMetric("filtsize", false);
              this.visualization.setSortX("normal", false);
            }
            else{
              this.visualization.setMetric("filtsize", false);
              this.visualization.setSortX("filtsize_des", false);
              if(cType === "heatmap"){
                this.visualization.setMetric("filtsize", false);
                this.visualization.setColor("filtsize", false);
                this.visualization.setSortX("clustering", false);
                this.visualization.setSortY("clustering", false);
              }
              if(["barchart","columnchart"].includes(cType)){
                this.visualization.setDataLimit(true, false);
                this.query.data_limits = {
                  enabled: true,
                  limit: 100
                };
                this.visualization.setQuery(query, false);
              }
            }
            //this.$emit("setDefault", this.settings);
        }
        else{
            if(cType === 'scatterplot'){
              this.visualization.setMetricX("recency", false);
              this.visualization.setMetricY("size", false);
              this.visualization.setDataLimit(true, false);
            }
            else if(cType === 'linechart'){
              this.visualization.setMetric("size", false);
              this.visualization.setSortX("normal", false);
            }
            else if(cType === "heatmap"){
              this.visualization.setMetric("size", false);
              this.visualization.setColor("size", false);
              this.visualization.setSortX("clustering", false);
              this.visualization.setSortY("clustering", false);
            }
            else{
              this.visualization.setMetric("size", false);
              this.visualization.setSortX("size_des", false);
              if(["barchart","columnchart"].includes(cType)){
                this.visualization.setDataLimit(true, false);
                this.query.data_limits = {
                  enabled: true,
                  limit: 100
                };
                this.visualization.setQuery(query, false);
              }
            }
            //this.$emit("setDefault", this.settings);
        }
        /*let zCallBack = zOptions => {
          this.sortZOptions = zOptions;
          this.sortZ = zOptions[0].value;
        };
        let rangeCallback = (sizeRange, recencyRange, status) => {
          this.defaultsLoaded = status;
          this.sizeLimit = sizeRange;
          this.sizeRange = sizeRange;
          this.recencyLimit = reccType === "barchart"encyRange;
          this.recencyRange = recencyRange;
        };
        let metricCallback = metricOptions => {
          this.colorOptions = metricOptions;
          if (cType === "scatterplot") {
            this.metricXOptions = metricOptions;
            this.metricYOptions = metricOptions;
            if (!this.metricX) {
              this.metricX = "recency";
              this.metricY = "size";
              this.logMetricX = false;
              this.logMetricY = true;
            }
            if (
              metricOptions.filter(x => x.value === this.metricX).length === 0
            ) {
              this.metricX = "recency";
              this.logMetricX = true;
            }
            if (
              metricOptions.filter(x => x.value === this.metricY).length === 0
            ) {
              this.metricY = "size";
              this.logMetricY = false;
            }
          }
        };*/
        
        const inputs = update? this.settings:null;
        //this.visualization.setMetric("filtsize");
        //this.visualization.setColor("filtsize");
        //this.visualization.setMetricX("filtrecency");
        //this.visualization.setMetricY("filtsize");
        this.visualization.draw(
          true,
          //zCallBack,
          //metricCallback,
          //rangeCallback,
          cType,
          inputs
        );
      }
      }
    },
    showOptions(item) {
      this.selectRow(item);
      EventBus.$emit(
        "showOptions",
        this.selectedRows.length > 0 ? [this.selectedRows] : null
      );
    },
    selectRow(row) {
      if (
        _.find(this.selectedRowIds, r => {
          return r._id === row.id;
        }) !== undefined
      ) {
        if (this.selectedRowIds.length > 1) {
          if (
            _.findIndex(this.selectedRowIds, r => {
              return r._id === row.id;
            }) === 0
          ) {
            this.selectedRowIds.splice(
              _.findIndex(this.selectedRowIds, r => {
                return r._id === row.id;
              }),
              2
            );
            this.selectedRows.splice(
              _.findIndex(this.selectedRows, r => {
                return r.id === row.id;
              }),
              1
            );
          } else {
            this.selectedRowIds.splice(
              _.findIndex(this.selectedRowIds, r => {
                return r._id === row.id;
              }) - 1,
              2
            );
            this.selectedRows.splice(
              _.findIndex(this.selectedRows, r => {
                return r.id === row.id;
              }),
              1
            );
          }
        } else {
          this.selectedRowIds = this.selectedRows = [];
        }
      } else {
        if (this.selectedRowIds.length > 0) {
          this.selectedRowIds.push("OR");
        }
        this.selectedRowIds.push({ _id: row.id });
        this.selectedRows.push(row);
      }
      this.saveSubsetFilter(this.selectedRowIds);
      this.saveActiveVisual("#chart-" + this._uid + " svg");
    },
    isSelected(id) {
      if (
        _.find(this.selectedRowIds, r => {
          return r._id === id;
        }) !== undefined
      ) {
        return true;
      }
    },
    filterTable(table) {
      this.tableData = _.filter(table, row => {
        return (
          row.recency >= this.recencyLimit[0] &&
          row.recency <= this.recencyLimit[1] &&
          row.size >= this.sizeLimit[0] &&
          row.size <= this.sizeLimit[1]
        );
      });
    },
    sortTable(sorter) {
      if (["size", "recency"].includes(sorter)) {
        this.tableData = _.sortBy(this.tableData, [sorter]);
      } else if (["size_des", "recency_des"].includes(sorter)) {
        this.tableData = _.sortBy(this.tableData, [sorter.split("_")[0]]);
        this.tableData = _.reverse(this.tableData);
      } else {
        this.tableData = _.sortBy(this.tableData, ["name"]);
      }
    },
    async modifyQueryForFilterGroup(query){
      return new Promise(async (resolve, reject) => {
        let newQuery = query;
        if(query.xlayers[0] && (query.xlayers[0].layers.includes('filtergroup') || query.xlayers[0].layers.includes('filtersubgroup'))){
          let group = query.xlayers[0].layers[0];
          let layers = [];
          const updatedLayers = await getMemberFilters(null, group==="filtergroup"? "filtergroup":"filtersubgroup");
          //console.log(updatedLayers);
          updatedLayers.forEach(async (layer, n) => {
            const exists = await getFiltId(null, layer.label)
            if(exists){
              let filter = {
                _id: exists.id,
                updated_date: null,
                name: layer.label,
                type: "filter",
                query: layer.items
              }
              const tempmaincat = await getFiltId(null, "tempmaincat");
              const tempsubcat = await getFiltId(null, "tempsubcat");
              const tempfiltId = await this.saveTempFilter(
                filter,
                tempmaincat? { _id: tempmaincat.id }:{ "name": "tempmaincat" },
                tempsubcat? { _id: tempsubcat.id }:{ "name": "tempsubcat" }
              );
              layers.push(tempfiltId);
            }
            else{
              let filter = {
                name: layer.label,
                type: "filter",
                query: layer.items
              }
              const tempmaincat = await getFiltId(null, "tempmaincat");
              const tempsubcat = await getFiltId(null, "tempsubcat");
              const tempfiltId = await this.saveTempFilter(
                filter,
                tempmaincat? { _id: tempmaincat.id }:{ "name": "tempmaincat" },
                tempsubcat? { _id: tempsubcat.id }:{ "name": "tempsubcat" }
              );
              layers.push(tempfiltId);
            }
            if(updatedLayers.length === n+1){
              //console.log(layers);
              newQuery.xlayers[0].layers = layers;
              if(query.ylayers[0] && (query.ylayers[0].layers.includes('filtergroup') || query.ylayers[0].layers.includes('filtersubgroup'))){
                let group = query.ylayers[0].layers[0];
                let layers = [];
                const updatedLayers = await getMemberFilters(null, group==="filtergroup"? "filtergroup":"filtersubgroup");
                //console.log(updatedLayers);
                updatedLayers.forEach(async (layer, n) => {
                  const exists = await getFiltId(null, layer.label)
                  if(exists){
                    let filter = {
                      _id: exists.id,
                      updated_date: null,
                      name: layer.label,
                      type: "filter",
                      query: layer.items
                    }
                    const tempmaincat = await getFiltId(null, "tempmaincat");
                    const tempsubcat = await getFiltId(null, "tempsubcat");
                    const tempfiltId = await this.saveTempFilter(
                      filter,
                      tempmaincat? { _id: tempmaincat.id }:{ "name": "tempmaincat" },
                      tempsubcat? { _id: tempsubcat.id }:{ "name": "tempsubcat" }
                    );
                    layers.push(tempfiltId);
                  }
                  else{
                    let filter = {
                      name: layer.label,
                      type: "filter",
                      query: layer.items
                    }
                    const tempmaincat = await getFiltId(null, "tempmaincat");
                    const tempsubcat = await getFiltId(null, "tempsubcat");
                    const tempfiltId = await this.saveTempFilter(
                      filter,
                      tempmaincat? { _id: tempmaincat.id }:{ "name": "tempmaincat" },
                      tempsubcat? { _id: tempsubcat.id }:{ "name": "tempsubcat" }
                    );
                    layers.push(tempfiltId);
                  }
                  if(updatedLayers.length === n+1){
                    //console.log(layers);
                    newQuery.ylayers[0].layers = layers;
                    resolve(newQuery);
                  }  
                })
              }
              else{
                resolve(newQuery);
              }
            }  
          })
        }
        else{
          resolve(newQuery);
        }
      })
    },
    async saveTempFilter(filter, category, subcategory){
      return new Promise((resolve, reject) => {
        this.saveFilter({
          filter: filter,
          category: category,
          subcategory: subcategory
        }).then((res) => {
          resolve(res._id)
        })
      })
    },
    startVisCheckInt(){
      this.visDrawCheck = setInterval(() => {
      if(document.getElementById("chart-" + this._uid) && document.getElementById("chart-" + this._uid).querySelector("svg") && document.getElementById("chart-" + this._uid).querySelector("svg").hasChildNodes()){
          this.showLoader = false;
        }
        else{
          this.showLoader = true;
        }
      }, 500)
    }
  }
};
</script>
